//#region Imports

import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { NgIf } from '@angular/common';

//#endregion

@Component({
    selector: 'app-ribbon',
    templateUrl: './ribbon.component.html',
    imports: [
        NgIf
    ]
})
export class RibbonComponent {

  //#region Constructor

  constructor() {
    if (environment.production)
      this.show = false;
    else if (environment.staging)
      this.name = 'Staging';
    else if (environment.qas)
      this.name = 'QAs';
    else
      this.name = 'Develop';
  }

  //#endregion

  //#region Public Properties

  public show = true;

  public name = '';

  //#endregion

}
